module.exports = __webpack_public_path__ + "img/main.8980d78d.jpg";